import { useQuery, useQueryClient } from '@tanstack/react-query';

import {
  klassesQueryKeys,
  scheduledLessonsQueryKeys,
} from '@/data/services/querykeys';

export default function useScheduledLessonReportData(
  scheduledLessonId: number,
) {
  const queryClient = useQueryClient();

  const hasScheduledLessonId = !isNaN(scheduledLessonId);

  const { queryFn: scheduledLessonQueryFn, queryKey: scheduledLessonQueryKey } =
    scheduledLessonsQueryKeys.get(scheduledLessonId);

  const {
    data: scheduledLesson,
    isInitialLoading: loadingScheduledLesson,
    error: scheduledLessonError,
  } = useQuery({
    queryFn: scheduledLessonQueryFn,
    queryKey: scheduledLessonQueryKey,
    enabled: hasScheduledLessonId,
  });

  const klassId = scheduledLesson?.klass;

  const {
    data: klass,
    isInitialLoading: loadingKlass,
    error: klassError,
  } = useQuery({
    ...klassesQueryKeys.get(klassId ?? 0),
    enabled: !!klassId,
  });

  const invalidateScheduledLesson = async () =>
    await queryClient.invalidateQueries({ queryKey: scheduledLessonQueryKey });

  return {
    klass,
    scheduledLesson,
    invalidateScheduledLesson,
    loading: loadingKlass || loadingScheduledLesson,
    error: klassError || scheduledLessonError,
  };
}
